import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  ButtonItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import { Button, DataGrid, Accordion, LoadPanel } from "devextreme-react";
import UserInfo from "../../../UserInfo";
import ShowError from "../../../AppServices";
import api from "../../../api-axios";
import apiRelatorios from "../../../api-reports";
import {
  Column,
  Editing,
  Pager,
  Paging,
  Selection,
} from "devextreme-react/data-grid";
import uiInfo from "../../../ui-info";
import LivroParametroTitulo from "./LivroParametroTitulo";
import LivroParametroForm from "./LivroParametroForm";
import { showReportDirect } from "../../../showReport";
import HtmlEditor, { Toolbar, Item } from "devextreme-react/html-editor";
import { LoadIndicator } from "devextreme-react/load-indicator";


export default class GerarLivroDiat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      exercicio: "",
      livrosDiat: [],
      booksParameters: [],
      selectedBooks: [],
      _uiMsgCarregamento: "",
      declaracaoDiatDados: {
        estilo: 0
      }
    };

    this.estiloOptions = {
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: " " },
        { id: 1, descricao: "CANCELAMENTO E PRESCRIÇÃO SEPARADOS" },
        { id: 2, descricao: "CANCELAMENTO E PRESCRIÇÃO JUNTOS" }
      ],
      placeholder: " ",
      valueExpr: "id",
      displayExpr: "descricao"
    };


    this._gridInstance = React.createRef();
    this.startBookGenerate = this.startBookGenerate.bind(this);
    this.startBookClosing = this.startBookClosing.bind(this);
    this.startBookReopening = this.startBookReopening.bind(this);
    this.closeBooks = this.closeBooks.bind(this);
    this.reopenBooks = this.reopenBooks.bind(this);
    this.generateBooks = this.generateBooks.bind(this);
    this.buscarInfoDeclaracao = this.buscarInfoDeclaracao.bind(this);
    this.valueChangedOnText = this.valueChangedOnText.bind(this);
    this.salvarDeclaracao = this.salvarDeclaracao.bind(this);




  }

  valueChangedOnText(e) {
    this.setState({
      declaracaoDiatDados: {
        ...this.state.declaracaoDiatDados,
        texto: e.value
      }
    });

    console.log(this.state);
  }

  render() {


    if (this.state._uiMsgCarregamento && this.state._uiMsgCarregamento != "") {

      return <div className={"content-block dx-card responsive-paddings"}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: "25px",
            justifyContent: "center",
            alignContent: "center",
            justifyItems: "center",
            alignItems: "center",
          }}
        >
          <LoadIndicator width={60} height={60} />
          {this.state._uiMsgCarregamento}
        </div>
      </div>
    }




    return (
      <React.Fragment>
        <div
          className={"content-block dx-card responsive-paddings"}
          id="generate-book"
        >
          <LoadPanel
            shadingColor="rgba(0,0,0,0.4)"
            position={{ of: "generate-book" }}
            visible={this.state.loadPanelVisible}
            showIndicator={true}
            shading={true}
            showPane={true}
            hideOnOutsideClick={false}
            message={"Gerando livros, aguarde..."}
          />
          <h3 style={{ padding: 0, margin: 0 }}>LIVROS DA DÍVIDA ATIVA</h3>
          <hr />
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={200}
                text="Abertura de Livro"
                type="success"
                onClick={() =>
                  this.setState({
                    _uiView: "aberturalivro"
                  })
                }
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button
                text="Fechamento de Livro"
                type="danger"
                onClick={this.startBookClosing}
                width={200}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button
                text="Reabertura de Livro"
                type="default"
                onClick={this.startBookReopening}
                width={200}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button
                text="Declaração"
                type="default"
                onClick={() => this.setState({ _uiView: "gerardeclaracao" })}
                width={200}
              />
            </div>
          </div>
          <br />
          <div
            style={{
              display: this.state._uiView == "aberturalivro" ? "" : "none",
            }}
          >
            <form>
              <Form formData={this.state} colCount={2} labelLocation="top">
                <GroupItem
                  caption="LIVROS DÍVIDA ATIVA"
                  colSpan={2}
                  colCount={6}
                >
                  <SimpleItem dataField={"exercicio"} colSpan={2}>
                    <Label text="Exercício" />
                  </SimpleItem>
                  <ButtonItem
                    horizontalAlignment={"center"}
                    verticalAlignment={"bottom"}
                    visible={this.state.aberturaLivro}
                    buttonOptions={{
                      type: "success",
                      text: "Iniciar Geração",
                      onClick: this.startBookGenerate,
                      width: "250px",
                    }}
                  />
                </GroupItem>
              </Form>
            </form>
            <div
              style={{
                display: this.state.booksParameters.length > 0 ? "" : "none",
              }}
            >
              <h3>LIVROS</h3>
              <Accordion
                dataSource={this.state.booksParameters}
                activeStateEnabled={false}
                collapsible={true}
                multiple={true}
                animationDuration={300}
                itemTitleRender={LivroParametroTitulo}
                itemRender={LivroParametroForm}
              />
              <br />
              <div
                style={{
                  display: "flex",
                  marginTop: "25px",
                  justifyContent: "center",
                  alignContent: "center",
                  justifyItems: "center",
                  alignItems: "center",
                }}
              >
                <Button
                  text="Gerar livros"
                  type="success"
                  onClick={this.generateBooks}
                  width={200}
                />
              </div>
            </div>
          </div>

          <div
            style={{
              display:
                (this.state._uiView == "fechamentolivro" || this.state._uiView == "reaberturalivro") &&
                  this.state.livrosDiat.length > 0
                  ? ""
                  : "none",
            }}
          >
            <h3>Livros cadastrados</h3>
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.state.livrosDiat}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              filterSyncEnabled={true}
              wordWrapEnabled={true}
              onSelectionChanged={({ selectedRowKeys }) =>
                this.setState({ selectedBooks: selectedRowKeys })
              }
            >
              <Editing allowDeleting={false} allowUpdating={false} />
              <Selection
                mode="multiple"
                selectAllMode="allPages"
                showCheckBoxesMode="always"
              />
              <Column dataField={"ano"} caption={"Exercício"} />
              <Column dataField={"numero"} caption={"Número"} />
              <Column dataField={"titulo"} caption={"Título"} />
              <Column
                dataField={"qtdeItens"}
                caption={"Quantidade de Registros"}
              />
              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
            <br />
            <div
              style={{
                display: "flex",
                marginTop: "25px",
                justifyContent: "center",
                alignContent: "center",
                justifyItems: "center",
                alignItems: "center",
              }}
            >
              <Button
                text={
                  this.state._uiBookOperation == "fechar"
                    ? "Fechar livros"
                    : "Reabrir livros"
                }
                type={this.state.fechamentoLivro ? "danger" : "success"}
                onClick={
                  this.state._uiBookOperation == "fechar"
                    ? this.closeBooks
                    : this.reopenBooks
                }
                width={200}
              />
            </div>
          </div>

          <div
            style={{
              display: this.state._uiView == "gerardeclaracao" ? "" : "none",
            }}
          >
            <form>
              <Form formData={this.state} colCount={2} labelLocation="top">
                <GroupItem
                  caption="DECLARAÇÃO DA DIVIDA ATIVA"
                  colSpan={2}
                  colCount={10}
                >
                  <SimpleItem dataField={"exercicio"} colSpan={2} editorOptions={{ width: "100%" }}>
                    <Label text="Exercício" />
                  </SimpleItem>

                  <ButtonItem
                    colSpan={4}
                    horizontalAlignment={"left"}
                    verticalAlignment={"bottom"}
                    buttonOptions={{
                      type: "success",
                      text: "Buscar informações",
                      onClick: this.buscarInfoDeclaracao,
                      width: "250"
                    }}
                  />
                </GroupItem>
              </Form>
            </form>

            <form>
              <Form formData={this.state.declaracaoDiatDados} colCount={2} labelLocation="top">



                <GroupItem caption="TEXTO" colSpan={2} colCount={1}>

                  <HtmlEditor
                    height={"300px"}
                    mediaResizing={this.enabled}
                    value={this.state.declaracaoDiatDados?.texto}
                    onValueChanged={this.valueChangedOnText}
                  >
                    <Toolbar>
                      <Item formatName="undo" />
                      <Item formatName="redo" />
                      <Item formatName="separator" />
                      <Item formatName="size" formatValues={this.sizeValues} />
                      <Item formatName="font" formatValues={this.fontValues} />
                      <Item formatName="separator" />
                      <Item formatName="bold" />
                      <Item formatName="italic" />
                      <Item formatName="strike" />
                      <Item formatName="underline" />
                      <Item formatName="separator" />
                      <Item formatName="alignLeft" />
                      <Item formatName="alignCenter" />
                      <Item formatName="alignRight" />
                      <Item formatName="alignJustify" />
                      <Item formatName="separator" />
                      <Item formatName="header" formatValues={this.headerValues} />
                      <Item formatName="separator" />
                      <Item formatName="orderedList" />
                      <Item formatName="bulletList" />
                      <Item formatName="separator" />
                      <Item formatName="color" />
                      <Item formatName="background" />
                      <Item formatName="separator" />
                      <Item formatName="link" />
                      <Item formatName="image" />
                      <Item formatName="separator" />
                      <Item formatName="clear" />
                      <Item formatName="codeBlock" />
                      <Item formatName="blockquote" />
                    </Toolbar>
                  </HtmlEditor>
                </GroupItem>

                <GroupItem
                  caption="DIVIDA ATIVA TRIBUTÁRIA"
                  colSpan={1}
                >
                  <SimpleItem dataField={"dadosT.saldoInicial"} colSpan={1}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                    cssClass={"txtFrmCpbsNumerico"}
                    editorType={"dxNumberBox"}>
                    <Label text="Saldo Inicial" />
                  </SimpleItem>

                  <SimpleItem dataField={"dadosT.inscricao"} colSpan={1}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                    cssClass={"txtFrmCpbsNumerico"}
                    editorType={"dxNumberBox"}>
                    <Label text="Inscrição" />
                  </SimpleItem>

                  <SimpleItem dataField={"dadosT.arrecadacao"} colSpan={1}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                    cssClass={"txtFrmCpbsNumerico"}
                    editorType={"dxNumberBox"}>
                    <Label text="Arrecadação" />
                  </SimpleItem>

                  <SimpleItem dataField={"dadosT.prescricao"} colSpan={1}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                    cssClass={"txtFrmCpbsNumerico"}
                    editorType={"dxNumberBox"}>
                    <Label text="Prescrição" />
                  </SimpleItem>

                  <SimpleItem dataField={"dadosT.cancelamento"} colSpan={1}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                    cssClass={"txtFrmCpbsNumerico"}
                    editorType={"dxNumberBox"}>
                    <Label text="Cancelamentos" />
                  </SimpleItem>

                  <SimpleItem dataField={"dadosT.saldoFinal"} colSpan={1}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2, readOnly: true }}
                    cssClass={"txtFrmCpbsNumerico"}
                    editorType={"dxNumberBox"}>
                    <Label text="Saldo Final" />
                  </SimpleItem>
                </GroupItem>

                <GroupItem
                  caption="DIVIDA ATIVA NÃO TRIBUTÁRIA"
                  colSpan={1}
                >
                  <SimpleItem dataField={"dadosNt.saldoInicial"} colSpan={1}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                    cssClass={"txtFrmCpbsNumerico"}
                    editorType={"dxNumberBox"}>
                    <Label text="Saldo Inicial" />
                  </SimpleItem>

                  <SimpleItem dataField={"dadosNt.inscricao"} colSpan={1}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                    cssClass={"txtFrmCpbsNumerico"}
                    editorType={"dxNumberBox"}>
                    <Label text="Inscrição" />
                  </SimpleItem>

                  <SimpleItem dataField={"dadosNt.arrecadacao"} colSpan={1}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                    cssClass={"txtFrmCpbsNumerico"}
                    editorType={"dxNumberBox"}>
                    <Label text="Arrecadação" />
                  </SimpleItem>

                  <SimpleItem dataField={"dadosNt.prescricao"} colSpan={1}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                    cssClass={"txtFrmCpbsNumerico"}
                    editorType={"dxNumberBox"}>
                    <Label text="Prescrição" />
                  </SimpleItem>

                  <SimpleItem dataField={"dadosNt.cancelamento"} colSpan={1}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
                    cssClass={"txtFrmCpbsNumerico"}
                    editorType={"dxNumberBox"}>
                    <Label text="Cancelamentos" />
                  </SimpleItem>

                  <SimpleItem dataField={"dadosNt.saldoFinal"} colSpan={1}
                    editorOptions={{ format: uiInfo.formatoNumerico.n2, readOnly: true }}
                    cssClass={"txtFrmCpbsNumerico"}
                    editorType={"dxNumberBox"}>
                    <Label text="Saldo Final" />
                  </SimpleItem>
                </GroupItem>


                <ButtonItem
                  horizontalAlignment={"center"}
                  verticalAlignment={"bottom"}
                  colSpan={2}
                  buttonOptions={{
                    type: "success",
                    text: "Salvar Declração",
                    onClick: this.salvarDeclaracao,
                    width: "250px",
                  }}
                />
              </Form>
            </form>
            <br />
            <DataGrid
              dataSource={this.state.declaracaoDiatDados?.relatorios}
              showBorders={true}
              rowAlternationEnabled={true}
              columnAutoWidth={true}
            >
              <Column dataField={"titulo"}>
              </Column>
              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                buttons={[
                  {
                    hint: "Imprimir",
                    icon: "exportpdf",
                    onClick: (e) => {
                      if (e.row.data.titulo.includes("zip")) {
                        let pdf = {
                          file: `data:application/pdf;base64,${e.row.data.rptStr}`,
                          file_name: e.row.data.titulo
                        };

                        const pdfLink = `${pdf.file}`;
                        const anchorElement = document.createElement('a');
                        const fileName = `${pdf.file_name}`;
                        anchorElement.href = pdfLink;
                        anchorElement.download = fileName;
                        anchorElement.click();
                      } else {
                        showReportDirect(e.row.data.rptStr);
                      }
                    }
                  }
                ]}
              />
            </DataGrid>
          </div>
        </div>
      </React.Fragment>
    );
  }

  async buscarInfoDeclaracao() {

    const exercicio = this.state.exercicio;

    if (!exercicio) {
      notify("Ano de exercício não informado", "error");
      return;
    }

    try {
      this.setState({ _uiMsgCarregamento: "Buscando dados..." });

      const response = await apiRelatorios.get(
        `/diat/gerar_dados_declaracao/${UserInfo.getPrefeitura()}/${exercicio}/0/`
      );
      if (response.data) {
        this.setState({ declaracaoDiatDados: response.data });
      }
    } catch (error) {
      if (error.response && error.response.data) {
        ShowError(error.response.data);
      } else {
        ShowError(error);
      }
    }
    finally {
      this.setState({ _uiMsgCarregamento: "" });
    }
  }

  async salvarDeclaracao() {

    const exercicio = this.state.exercicio;

    if (!exercicio) {
      notify("Ano de exercício não informado", "error");
      return;
    }

    var request = {
      ...this.state.declaracaoDiatDados,
      estilo: this.state.estilo,
      exercicio,
    };

    console.log("request salvar declaracao", request);

    try {

      this.setState({ _uiMsgCarregamento: "Salvando declaração..." });

      const response = await apiRelatorios.post(`/diat/salvar_declaracao/${UserInfo.getPrefeitura()}`, request);

      if (response.data) {
        this.setState({ declaracaoDiatDados: response.data });
      }
    } catch (error) {
      console.log("error salvar", error);
      if (error.response && error.response.data) {
        ShowError(error.response.data);
      } else {
        ShowError(error);
      }
    }
    finally {
      this.setState({ _uiMsgCarregamento: "" });
      notify("Dados salvos com sucesso!", "success");
    }
  }

  async startBookGenerate() {
    const exercicio = this.state.exercicio;
    if (!exercicio) {
      notify("Ano de exercício não informado", "error");
    } else {
      try {
        this.setState({ _uiMsgCarregamento: "Buscando dados..." })
        const response = await api.post(
          `/parametros_livro/gerar_livros_preview/${UserInfo.getPrefeitura()}/${exercicio}`
        );
        if (response.data) {
          this.setState({ booksParameters: response.data });
        }
      } catch (error) {
        if (error.response && error.response.data) {
          ShowError(error.response.data);
        } else {
          ShowError(error);
        }
      }
      finally {
        this.setState({ _uiMsgCarregamento: "" });
      }
    }
  }

  async startBookClosing() {
    this.setState({ _uiView: "fechamentolivro", _uiMsgCarregamento: "Buscando dados...", _uiBookOperation: "fechar" });
    try {
      const response = await api.post(
        `/parametros_livro/fechamento_livros_preview/${UserInfo.getPrefeitura()}/`
      );
      if (response.data) {
        this.setState({ livrosDiat: response.data });
      }
    } catch (error) {
      if (error.response && error.response.data) {
        ShowError(error.response.data);
      } else {
        ShowError(error);
      }
    }
    finally {
      this.setState({ _uiMsgCarregamento: "" });
    }
  }

  async closeBooks() {
    const selectedClosingBooks = this.state.selectedBooks;
    console.log(selectedClosingBooks);
    if (selectedClosingBooks.length > 0) {
      try {
        const response = await api.post(
          `/parametros_livro/fechar_livro/${UserInfo.getPrefeitura()}/`,
          selectedClosingBooks
        );

        if (response.data) {
          notify("Livros excluídos com sucesso!", "success", 2000);
          this.setState({ livrosDiat: response.data });
        }
      } catch (error) {
        if (error.response && error.response.data) {
          ShowError(error.response.data);
        } else {
          ShowError(error);
        }
      }
    }
  }

  async reopenBooks() {
    const selectedClosingBooks = this.state.selectedBooks;
    console.log(selectedClosingBooks);
    if (selectedClosingBooks.length > 0) {
      try {
        const response = await api.post(
          `/parametros_livro/reabrir_livros/${UserInfo.getPrefeitura()}/`,
          selectedClosingBooks
        );
        if (response.data) {
          notify("Livros reabertos com sucesso!", "success", 2000);
          this.setState({ livrosDiat: response.data });
        }
      } catch (error) {
        if (error.response && error.response.data) {
          ShowError(error.response.data);
        } else {
          ShowError(error);
        }
      }
    }
  }

  async startBookReopening() {
    this.setState({ _uiView: "reaberturalivro", _uiMsgCarregamento: "Buscando dados...", _uiBookOperation: "reabrir" });

    try {
      const response = await api.post(
        `/parametros_livro/reabrir_livros_preview/${UserInfo.getPrefeitura()}`
      );
      if (response.data) {
        this.setState({ livrosDiat: response.data });
      }
    } catch (error) {
      if (error.response && error.response.data) {
        ShowError(error.response.data);
      } else {
        ShowError(error);
      }
    }
    finally {
      this.setState({ _uiMsgCarregamento: "" });
    }
  }

  async generateBooks() {
    this.setState({ loadPanelVisible: true });
    try {
      const response = await api.post(
        `/parametros_livro/gerar_livros/${UserInfo.getPrefeitura()}/`,
        this.state.booksParameters
      );
      if (response.data) {
        notify("Livros gerados com sucesso!", "success", 2000);
      }
    } catch (error) {
      if (error.response && error.response.data) {
        ShowError(error.response.data);
      } else {
        ShowError(error);
      }
    }
    finally {
      this.setState({
        loadPanelVisible: false,
        booksParameters: [],
        exercicio: null,
      });
    }
  }
}
